module.exports = __webpack_public_path__ + "img/logo1.7d90841e.png";